export function isValidInteger(value: string | number): value is number {
    // Remove non-numeric characters except the decimal point
    const sanitizedValue = String(value).replace(/[^\d.]/g, '');
    const numberValue = parseFloat(sanitizedValue);

    return !isNaN(numberValue) && Number.isInteger(numberValue);
}
